import * as React from 'react';
import { observer } from 'mobx-react';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { PrimaryButton, DefaultButton, ButtonType } from 'office-ui-fabric-react/lib/Button';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { ChoiceGroup, IChoiceGroupOption } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { toggleConnectGmailWindow } from '../actions/connectGmail/toggleConnectGmailWindow';
import { updateGmailDisplayName } from '../actions/connectGmail/updateGmailDisplayName';
import { updateGmailIsSendOnly } from '../actions/connectGmail/updateGmailIsSendOnly';
import { updateGmailTargetRootFolderEnabled } from '../actions/connectGmail/updateGmailTargetRootFolderEnabled';
import { connectedAccountsStore } from '../store/store';
import { connectGmail } from '../utils/connectGmail';
import strings from 'owa-strings/owa-options-strings';

const styles = require('./ConnectGmailWindow.scss');

@observer
export default class ConnectGmailWindow extends React.Component<{}, {}> {
    private onClose = () => {
        toggleConnectGmailWindow({ connectGmailOpen: false });
    };

    private onConnectGroupSelected = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption
    ) => {
        let isSendOnly = option.key == 'SendOnly';
        updateGmailIsSendOnly(isSendOnly);
    };

    private onStorageSelected = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption
    ) => {
        let targetRootFolderEnabled = option.key == 'NewFolder';
        updateGmailTargetRootFolderEnabled(targetRootFolderEnabled);
    };

    render() {
        let store = connectedAccountsStore();

        return (
            <Dialog
                hidden={!store.dialogWindowState.connectGmailOpen}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: strings.options_connected_gmail_title,
                }}
                modalProps={{
                    isBlocking: true,
                    containerClassName: styles.dialog,
                    onDismiss: this.onClose,
                }}>
                <TextField
                    label={strings.options_connected_gmail_displayNameTextField}
                    onChanged={updateGmailDisplayName}
                    disabled={store.connectGmailState.isConnecting}
                />
                <ChoiceGroup
                    options={[
                        {
                            key: 'Connected',
                            text: strings.options_connected_gmail_connectedOption,
                            checked: !store.connectGmailState.isSendOnly,
                        },
                        {
                            key: 'SendOnly',
                            text: strings.options_connected_gmail_sendOnlyOption,
                            checked: store.connectGmailState.isSendOnly,
                        },
                    ]}
                    required={true}
                    onChange={this.onConnectGroupSelected}
                    className={styles.marginTop}
                    disabled={store.connectGmailState.isConnecting}
                />
                {!store.connectGmailState.isSendOnly && (
                    <ChoiceGroup
                        options={[
                            {
                                key: 'NewFolder',
                                text: strings.options_connected_gmail_newFolderOption,
                                checked: store.connectGmailState.targetRootFolderEnabled,
                            },
                            {
                                key: 'ExistingFolder',
                                text: strings.options_connected_gmail_existingFolderOption,
                                checked: !store.connectGmailState.targetRootFolderEnabled,
                            },
                        ]}
                        required={true}
                        onChange={this.onStorageSelected}
                        label={strings.options_connected_gmail_targetOptionLabel}
                        className={styles.marginTop}
                        disabled={store.connectGmailState.isConnecting}
                    />
                )}
                <Label className={styles.marginTop}>
                    {strings.options_connected_gmail_connectLabel}
                </Label>
                <DialogFooter>
                    {store.connectGmailState.isConnecting && (
                        <Spinner size={SpinnerSize.large} className={styles.spinner} />
                    )}
                    <PrimaryButton
                        buttonType={ButtonType.primary}
                        onClick={connectGmail}
                        disabled={store.connectGmailState.isConnecting}>
                        {strings.options_connected_okButton}
                    </PrimaryButton>
                    <DefaultButton
                        onClick={this.onClose}
                        disabled={store.connectGmailState.isConnecting}>
                        {strings.options_connected_cancelButton}
                    </DefaultButton>
                </DialogFooter>
            </Dialog>
        );
    }
}
